var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgOrderError = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 15.0771H13V17.0771H11V15.0771ZM11 7.07715H13V13.0771H11V7.07715ZM11.99 2.07715C6.47 2.07715 2 6.55715 2 12.0771C2 17.5971 6.47 22.0771 11.99 22.0771C17.52 22.0771 22 17.5971 22 12.0771C22 6.55715 17.52 2.07715 11.99 2.07715ZM12 20.0771C7.58 20.0771 4 16.4971 4 12.0771C4 7.65715 7.58 4.07715 12 4.07715C16.42 4.07715 20 7.65715 20 12.0771C20 16.4971 16.42 20.0771 12 20.0771Z",
    fill: "#F43E3E"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgOrderError, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/order-error.3d92317f.svg";
export { ForwardRef as ReactComponent };